import React, { useContext, useState, useEffect, useCallback } from "react";
import { useNavigate, Navigate, useParams } from "react-router-dom";
import SimulatorHeader from "../../components/simulator-header/SimulatorHeader";
import PatternSelecttorButton from "../../components/pattern-selector-button/PatternSelectorButton";
import PatternSidebar from "../../components/pattern-sidebar/PatternSidebar";
import styles from "./PatternSelection.styles.scss";
import { UserContext } from "../../App";
import FadeIn from "react-lazyload-fadein";
import axios from "axios";
import TagManager from 'react-gtm-module';

const PatternSelection = () => {
    const navigate = useNavigate();
    const { environment: environmentParams, enviromentVariation: enviromentVariationParams } = useParams()
    const {
        envVariation,
        setEnvVariation,
        setEnvironment,
    } = useContext(UserContext);

    useEffect(() => {
        const getData = async () => {
            await axios
                .get(`${MIX_URL}/simulator-api/environments`)
                .then((response) => {
                    const result = response?.data?.environments
                    const environmentData = result?.find((item) => item?.slug === environmentParams);
                    const envVariationData = environmentData?.environment_options?.find((item) => item?.slug === enviromentVariationParams);

                    if (environmentData) setEnvironment(environmentData);

                    if (envVariationData) setEnvVariation(envVariationData);
                })
                .catch((err) => {
                    console.log(err);
                    setEnvVariation(null);
                    navigate("/escolha-um-ambiente");
                    navigate(0);
                });
        }

        if (envVariation === null && (!environmentParams || !enviromentVariationParams)) {
            setEnvVariation(null);
            navigate("/escolha-um-ambiente");
            navigate(0);
            console.log('Ambiente não selecionado');
        }

        if (envVariation === null) {
            getData();
        }
    }, []);

    return (
        <>
            {envVariation !== null ? <Content /> : <></>}
        </>
    )
}

const Content = () => {
    const {
        environment,
        envVariation,
        primaryPattern,
        setPrimaryPattern,
        secondaryPattern,
        setSecondaryPattern,
        thirdPattern,
        setThirdPattern,
        setStep,
        isTotem,
    } = useContext(UserContext);
    const navigate = useNavigate();

    const [patterns, setPatterns] = useState([]);
    useEffect(() => {
        axios
            .get(`${MIX_URL}/simulator-api/patterns/${envVariation.id}`)
            .then((response) => {
                setPatterns(response.data.patterns);

                response.data.patterns.forEach((pattern) => {
                    const paternImage = new Image();
                    paternImage.src = `${MIX_AWS_URL}/${pattern.thumb_image}`;

                    pattern.environment_option_patterns.forEach((opt) => {
                        const optImage = new Image();
                        optImage.src = `${MIX_AWS_URL}/${opt.image}`;
                    });
                });
            })
            .catch((err) => {
                navigate("/escolha-um-ambiente");
            });
    }, []);

    useEffect(() => {
        setStep(3);
    }, [])


    const arrayPatterns = [
        {
            pattern: null,
            editing: false,
            x: envVariation?.first_trigger_x,
            y: envVariation?.first_trigger_y,
        },
        {
            pattern: null,
            editing: false,
            x: envVariation?.second_trigger_x,
            y: envVariation?.second_trigger_y,
        },
        {
            pattern: null,
            editing: false,
            x: envVariation?.third_trigger_x,
            y: envVariation?.third_trigger_y,
        },
    ].filter((pattern) => {
        return pattern.x !== null;
    });

    const [patternSelectors, setPatternSelectors] = useState(arrayPatterns);

    const [editingPatternIndex, setEditingPatternIndex] = useState(null);
    const [patternSlug, setPatternSlug] = useState("");
    const updatePatternState = (index) => {
        let copy = [...patternSelectors];
        copy.forEach((cp) => {
            cp.editing = false;
        });
        copy[index].editing = true;
        setPatternSelectors(copy);
        setEditingPatternIndex(index);
    };
    const closePatternModal = () => {
        let copy = [...patternSelectors];
        copy[editingPatternIndex].editing = false;
        setPatternSelectors(copy);
        setEditingPatternIndex(null);
    };

    const selectPattern = useCallback(
        (pattern) => {
            let copy = [...patternSelectors];

            if (window.innerWidth <= 961) {
                copy[editingPatternIndex].editing = false;
            }

            setPatternSelectors(copy);
            const totemInfo = isTotem ? "totem_" : "";
            const event = {
                event: 'click',
                eventCategory: 'click',
                eventAction: totemInfo + `simulador_passo_03_click_${pattern?.slug}_0${editingPatternIndex}`
            };

            TagManager.dataLayer({ dataLayer: event });


            copy[editingPatternIndex].pattern = pattern;

            // let url = copy[0].pattern ? copy[0].pattern?.slug : "";
            // url += copy[1].pattern ? "|" + copy[1].pattern?.slug : "";

            let urlFilter = copy.filter((pattern) => {
                return pattern.pattern?.slug !== undefined;
            });

            let url = urlFilter
                .map((pattern) => {
                    return pattern.pattern?.slug;
                })
                .join("|");

            if (copy[0].pattern?.slug && copy[1].pattern?.slug) {
                setPatternSlug(url);
            }

            setPatternSelectors(copy);

            if (window.innerWidth <= 961) {
                setEditingPatternIndex(null);
            }

            if (editingPatternIndex == 0) {
                setPrimaryPattern(copy[0]);
            }

            if (editingPatternIndex == 1) {
                setSecondaryPattern(copy[1]);
            }

            if (editingPatternIndex == 2) {
                setThirdPattern(copy[2]);
            }
        },
        [patternSelectors, primaryPattern, secondaryPattern, thirdPattern]
    );

    const customLoad = (data, onLoad) => {
        onLoad(data);
    };

    return (
        <div className={`pattern-selection ${isTotem ? "totem" : ""}`}>
            {editingPatternIndex !== null && (
                <PatternSidebar
                    onClose={closePatternModal}
                    onSelect={selectPattern}
                    patterns={patterns}
                    currentIndex={editingPatternIndex}
                />
            )}
            <div
                className={`container w-full m-auto ${editingPatternIndex !== null ? "active" : ""
                    }`}
            >
                <SimulatorHeader
                    title="3. Selecione um padrão para experimentar"
                    prev={`/${environment.slug}/opcao-de-ambiente`}
                    next={
                        patternSlug
                            ? `/${environment.slug}/${envVariation.slug}/${patternSlug}`
                            : null
                    }
                />
                <div className="templates grid grid-cols-3 md:grid-cols-3">
                    <div className="image-container col-span-3">
                        <img
                            src={`${MIX_URL}/front-end/img/loading.gif`}
                            alt="Loading"
                            className="w-40 h-40 z-0 loading"
                        />
                        <FadeIn easing="ease-in-out">
                            {(onload) => (
                                <img
                                    src={`${MIX_AWS_URL}/${envVariation?.image}`}
                                    onLoad={onload}
                                    onError={onload}
                                />
                            )}
                        </FadeIn>
                        {patternSelectors.map((selector, index) => (
                            <React.Fragment key={index}>
                                <PatternSelecttorButton
                                    {...selector}
                                    index={index}
                                    onEditClick={updatePatternState}
                                />
                                {selector.pattern !== null && (
                                    <>
                                        <img
                                            key={selector.pattern.id}
                                            src={`${MIX_AWS_URL}/${selector.pattern.environment_option_patterns[index].image}`}
                                            className={`overlay_${index}_bkp`}
                                        />
                                        <FadeIn
                                            easing="ease-in"
                                            debounce={2000}
                                            throttle={2000}
                                            key={
                                                selector.pattern
                                                    .environment_option_patterns[
                                                    index
                                                ].image
                                            }
                                        >
                                            {(onload) => (
                                                <img
                                                    key={
                                                        selector.pattern
                                                            .environment_option_patterns[
                                                            index
                                                        ].image
                                                    }
                                                    src={`${MIX_AWS_URL}/${selector.pattern.environment_option_patterns[index].image}`}
                                                    onLoad={(data) => {
                                                        customLoad(
                                                            data,
                                                            onload
                                                        );
                                                    }}
                                                    onError={(data) => {
                                                        customLoad(
                                                            data,
                                                            onload
                                                        );
                                                    }}
                                                    className={`overlay_${index}`}
                                                />
                                            )}
                                        </FadeIn>
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatternSelection;
